export const state = {
  options: {
    position: 'top-right',
    duration: 2500
  }
};
